//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ServiceObjectMapPopupRequests from './ServiceObjectMapPopupRequests.vue'
import ServiceObjectMapPopupInformation from './ServiceObjectMapPopupInformation.vue'
import ServiceObjectMapPopupReports from './ServiceObjectMapPopupReports.vue'
import ServiceObjectMaintenanceNotes from '../../../forms/ServiceObject/ServiceObjectMaintenanceNotes.vue'

import { axiosGet } from '../../../axios/axios.js'
import { convertServiceObjectFromServerToServiceObjectMinimal } from '../../../forms/ServiceObject/ServiceObjectMinimal.js'
import { EventBus } from '../../../EventBus/EventBus.js'
import { loadNotes } from '../../../forms/ServiceObjectMaintenanceNote/ServiceObjectMaintenanceNotesTable.js'

export default {
  components: {
    ServiceObjectMapPopupRequests,
    ServiceObjectMapPopupInformation,
    ServiceObjectMapPopupReports,
    ServiceObjectMaintenanceNotes
  },
  props: {
    serviceObjectId: {
      type: Number,
      default: null
    },
    serviceObjectType: {
      type: String,
      default: null
    },
    mobile: {
      type: Boolean,
      default: false
    },
    requestsIds: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      selectedTab: 'requests',
      requestsNumber: 0,
      notFixedNotesAmount: 0,
      serviceObject: null,
      loading: false,
      accessToReportsHistory: false,

      requestsIdsLocal: [],
      serviceObjectNumber: ''
    }
  },
  computed: {
    serviceObjectName: function () {
      return this.serviceObject.name ? this.serviceObject.name.replace(' №', '') : ''
    },
    externalDispatcherBounded: function () {
      const user = this.$store.getters.getUser
      return user.hasRoleStrict('externalDispatcher') && !user.hasRole('dispatcher')
    },
    serviceObjectProjectsShortName: function () {
      let projectsMap = null
      if (this.serviceObject.type === 'trafficLight') {
        projectsMap = {
          '1140fb17-2962-11e9-a218-00155d231e03': 777, // "Контракт с ШВАБЕ-МОСКВА ООО №809/395 от 31.10.2018"
          '7b88a069-1369-11ef-8fe3-b8cb29ded2d6': 385, // "Государственный контракт с ГКУ ЦОДД №ТК385/24 от 22.04.2024г"
          'b3e43dac-2396-11f1-8fea-b8cb29ded2d6': 153 // "Государственный контракт с ГКУ ЦОДД №ТК153/26 от 18.03.2026г (безхозы)"
        }
      } else if (this.serviceObject.type === 'cameraTV') {
        projectsMap = {
          '1140fb17-2962-11e9-a218-00155d231e03': 777, // "Контракт с ШВАБЕ-МОСКВА ООО №809/395 от 31.10.2018"
          'b3e43dac-2396-11f1-8fea-b8cb29ded2d6': 153, // "Государственный контракт с ГКУ ЦОДД №ТК153/26 от 18.03.2026г (безхозы)"
          '73f128d2-7c10-11eb-a235-00155d231e03': 2109 // ГК с ГКУ ЦОДД №ТК2109/22 от 08.02.2022г (МКАД-ЦКАД установка камер)

        }
      }

      if (projectsMap && this.serviceObject.projects && this.serviceObject.projects.length) {
        return this.serviceObject.projects
          .map(p => projectsMap[p.key])
          .filter(Boolean)
          .join(', ')
      }
      return null
    }
  },
  watch: {
    serviceObjectId: function () {
      this.loadServiceObject()
    }
  },
  created: function () {
    this.accessToReportsHistory = this.$d_hasOperation('serviceObjectReportsView', true)
    this.loadServiceObject()

    EventBus.$on('update-request-popup', this.loadServiceObject)
  },
  beforeDestroy: function () {
    EventBus.$off('update-request-popup', this.loadServiceObject)
  },
  methods: {
    getServiceObjectIcon: function () {
      if (this.serviceObjectType === 'trafficLight') {
        return 'mdi-traffic-light'
      } else if (this.serviceObjectType === 'transportDetector') {
        return 'mdi-contactless-payment'
      } else if (this.serviceObjectType === 'TOI') {
        return 'mdi-monitor-dashboard'
      } else if (this.serviceObjectType === 'cameraFVF') {
        return 'mdi-camera-wireless'
      } else if (this.serviceObjectType === 'cameraTV') {
        return 'mdi-video-wireless'
      } else {
        return 'mdi-traffic-cone'
      }
    },
    onRequestCreated: function () {
      this.loadServiceObject(true)
      EventBus.$emit('update-request', {})
    },
    loadServiceObject: function (force = false) {
      if (this.serviceObjectId) {
        this.loading = true
        this.$emit('start-loading')

        let url = '/service/delta/dispatcher/serviceobject?id=' + this.serviceObjectId + '&recentRequests=true'
        if (this.serviceObjectType !== 'serviceObject') {
          url += '&type=' + this.serviceObjectType
        }
        axiosGet({
          url: url,
          onSuccess: (response) => {
            this.serviceObject = convertServiceObjectFromServerToServiceObjectMinimal(this.serviceObjectType, response.data)
            this.serviceObjectNumber = response.data.objectNumber
            this.loadServiceObjectRequests(force)
            this.loadServiceObjectMaintenanceNotes()
          },
          onFailure: () => {
            this.$q.notify({
              type: 'negative',
              message: 'Ошибка загрузки информации по объекту обслуживания',
              progress: true,
              timeout: 8000
            })

            this.loading = false
            this.$emit('end-loading')
          }
        }).finally(() => {
          this.loading = false
          this.$emit('end-loading')
        })
      }
    },
    loadServiceObjectRequests: function (force = false) {
      if ((!this.requestsIds || this.requestsIds.length === 0) || force === true) {
        this.loading = true

        axiosGet({
          url: '/service/delta/serviceobject/getServiceObjectActiveRequests?id=' + this.serviceObjectId,
          onSuccess: (response) => {
            this.requestsIdsLocal = response.data.result
          },
          onFailure: () => {
            this.$q.notify({
              type: 'negative',
              message: 'Ошибка загрузки заявок на объекте обслуживания',
              progress: true,
              timeout: 8000
            })

            this.requestsIdsLocal = []
            this.loading = false
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.requestsIdsLocal = this.requestsIds.slice()
      }
    },
    loadServiceObjectMaintenanceNotes: function () {
      return loadNotes({ id: this.serviceObject.id }).then(result => {
        this.notFixedNotesAmount = result.filter(note => note.maintenanceNoteStatus.key === 'notFixed').length
      })
    },
    getServiceObjectCardUrl: function () {
      return this.$d_getUrlObjectCard(this.serviceObject.id, this.serviceObject.type)
    }
  }
}

